export default {
    releases: [
        {
            name: "シルベ",
            description: "Single",
            releaseDate: "2026/01/04",
            artworkUrl: "https://yt3.googleusercontent.com/cM0AvO5uJ7EO3trU5ugGUKaMtDsq0Hl2N6EyK32oW7Q5kxJBPfdPS3_p11OGMo8FOlCemJG014Y88uKNaQ=w544-h544-l90-rj",
            releaseLink: "https://cover.lnk.to/shirube",
            isShow: true,
        },
        {
            name: "SHIN",
            description: "2nd Album",
            releaseDate: "2025/10/08",
            artworkUrl: "https://yt3.googleusercontent.com/9PXTGWYM3HzbH5UJLJEyFAIn1_D07TAWxY7iQmhKj-1NywP0vbfwzyWKJ8dQpAE1iuSguvAixCf9hr7V_w=w544-h544-l90-rj",
            releaseLink: "https://cover.lnk.to/SHIN",
            isShow: true,
        },
        {
            name: "S.T.Y.",
            description: "Single",
            releaseDate: "2024/01/04",
            artworkUrl: "https://yt3.googleusercontent.com/wUtfZN7Grsp0EQzt-Ok8dvHHHXUvevswDhtCDTDLbQTUNoJcni9M09nXANy_AH_7nVretHa_dEqol8k=w544-h544-l90-rj",
            releaseLink: "https://cover.lnk.to/S.T.Y.",
            isShow: true,
        },
        {
            name: "Aster",
            description: "1st Album",
            releaseDate: "2023/09/27",
            artworkUrl: "https://yt3.googleusercontent.com/dzgof5BVKbziem3nkkZ_zau_QJDApl0HlKDoGu8IQ47UH5Nt9xQz-IDuOgN10A-qRiw221ro5a9KXrZArw=w544-h544-l90-rj",
            releaseLink: "https://cover.lnk.to/Aster",
            isShow: true,
        },
        {
            name: "Scream",
            description: "EP",
            releaseDate: "2022/01/04",
            artworkUrl: "https://yt3.googleusercontent.com/DOHHEf7zQhCIsrkqggxRoTexe73k5ghDX4jRztEuZbMjcPEQlnFdKAVWlotNyc617ry0MeVhC1LtWJZ6=w544-h544-l90-rj",
            releaseLink: "https://cover.lnk.to/Scream",
            isShow: true,
        },
        {
            name: "バズビバザヴ",
            description: "",
            releaseDate: "2025/06/20",
            artworkUrl: "https://yt3.googleusercontent.com/rsgcTtYhOUtETYNT9EAqWxNwARu_MI_wzFmw6jNKprwQtjecIPlCMFmJlgtBwxK4LE1DqaNTbi0hkTbJEA=w544-h544-l90-rj",
            releaseLink: "https://cover.lnk.to/wQjgC3",
            isShow: false,
        },
        {
            name: "ChewyChewy",
            description: "",
            releaseDate: "2025/08/09",
            artworkUrl: "https://yt3.googleusercontent.com/mzi_OoboiPL3W4Ci4Cqkp7kOgEHZ6GoShLoa2CJGLuLzP4w7pD54AjKbFocNqEjUKFSqngMEIJ_v3vxg=w544-h544-l90-rj",
            releaseLink: "https://cover.lnk.to/dWnaPE",
            isShow: false,
        },
        {
            name: "My Abyss",
            description: "",
            releaseDate: "2025/03/02",
            artworkUrl: "https://yt3.googleusercontent.com/lKsWIWqr9yT2Y73lMyRsJaQ2adpts7JmLKe8uG6k4CTBP_i7TZc4yTZpVvrdimAAAJXFaS-Cr0tmEtVI=w544-h544-l90-rj",
            releaseLink: "https://cover.lnk.to/TxBlie",
            isShow: false,
        },
        {
            name: "ANEMONE",
            description: "",
            releaseDate: "2023/07/24",
            artworkUrl: "https://yt3.googleusercontent.com/HfeO4yAI_dlpvt3b9deYfRNgfSheNgIpJKscFyg4NkPf0D3o5_6YUeIwZDq5nZSdJtaLQUbOw-NNwnE=w544-h544-l90-rj",
            releaseLink: "https://cover.lnk.to/ANEMONE",
            isShow: false,
        },
        {
            name: "ライメイ",
            description: "",
            releaseDate: "2023/02/01",
            artworkUrl: "https://yt3.googleusercontent.com/1COY0opemlSzYey_Tm8x9yRbnr8ICRnvuiJ7yCgQ5vtT6ZoAySK7K26Jo0RSk7ndWW38r4nTecWsHtXbDg=w544-h544-l90-rj",
            releaseLink: "https://cover.lnk.to/raimei",
            isShow: false,
        },
        {
            name: "サンビタリア",
            description: "",
            releaseDate: "2023/08/09",
            artworkUrl: "https://yt3.googleusercontent.com/4q3rvtsYYQzUdSXkuI3qFsr6SJ4sj9y6j_OZe1IKI07_xg5v1hb-_cgMGVsVlqKNX7ZAdaM2t1sgmEE=w544-h544-l90-rj",
            releaseLink: "https://cover.lnk.to/Sanvitalia",
            isShow: false,
        },
        {
            name: "Palette",
            description: "",
            releaseDate: "2021/02/26",
            artworkUrl: "https://yt3.googleusercontent.com/1jbInQu8hyYIc6Mt5Kdm80BBHDG9fl4k1w0qL-dEGMwlIfAaY9K1CEiobc2WN7uzp3LsZJcDR-G8FlV6=w544-h544-l90-rj",
            releaseLink: "https://towa.streamlink.to/palette",
            isShow: false,
        },
        {
            name: "U.F.O. - U Feel Overjoyed! -",
            description: "",
            releaseDate: "2023/03/01",
            artworkUrl: "https://yt3.googleusercontent.com/CrNPdNVaz-VXP3F4h5xhMaW4qNqIISTPJkSNNeXy3mPBMyWny0A8mouDwTLpV5MKeAt7FE_XGaxPTtWY4g=w544-h544-l90-rj",
            releaseLink: "https://cover.lnk.to/UFeelOverjoyed",
            isShow: false,
        },
        {
            name: "君と明かした夜",
            description: "",
            releaseDate: "2025/09/02",
            artworkUrl: "https://yt3.googleusercontent.com/Ce9inFhNe8jc-OTVjTQygHh8eghIt13h_R_wH41nC7_Z44_aW-4eVPjrhgOpMg37Y4EcWqcIOwlYygU=w544-h544-l90-rj",
            releaseLink: "https://cover.lnk.to/AAUyjV",
            isShow: false,
        },
        {
            name: "Queen of the Night",
            description: "",
            releaseDate: "2025/07/30",
            artworkUrl: "https://yt3.googleusercontent.com/ptARdfNseSUcDXYtIJpJ9YD1qLeTjtnrHcf-xV6WqHN1B1sLIpxwpp9Wdt9dE0OopE_loJRrvezn0B1s=w544-h544-l90-rj",
            releaseLink: "https://cover.lnk.to/eyHtsR",
            isShow: false,
        },
        {
            name: "BEEP BEEP",
            description: "",
            releaseDate: "2026/04/18",
            artworkUrl: "https://yt3.googleusercontent.com/EeO-JQtBZkorioOg9wJ72HyB9nvpwj4JYkyhMfQc6RNl-pas13x93XGMfWpKFizzRHpBHrhjTvirxZkdQg=w544-h544-l90-rj",
            releaseLink: "https://cover.lnk.to/qmePp8",
            isShow: false,
        },
        {
            name: "GET THE CROWN",
            description: "",
            releaseDate: "2024/11/08",
            artworkUrl: "https://yt3.googleusercontent.com/j79wKKxIcJU9p9yS8ISuLEZzogAzORsK3_MgMqh556IgaVtvA8bPGAHyf4O6Q7qVX8nIxN6LWCHnSJU_rw=w544-h544-l90-rj",
            releaseLink: "https://cover.lnk.to/kQ6tL8",
            isShow: false,
        },
        {
            name: "水たまり",
            description: "",
            releaseDate: "2024/02/07",
            artworkUrl: "https://yt3.googleusercontent.com/WBtzF7vcb1n8uvUA_c0tdFW2bPyftYVOFu3RhWV3H_kCXnrJHcbQ4_6jiYaoqu7F-yVZKW5G3IsdUq9o=w544-h544-l90-rj",
            releaseLink: "https://sp.universal-music.co.jp/bluejourney/mizutamari/",
            isShow: false,
        },
        {
            name: "夜明けのうた",
            description: "",
            releaseDate: "2023/09/06",
            artworkUrl: "https://yt3.googleusercontent.com/4BEBs3mO-83BEw8f8X55dIM-WIq1_1r1zbVfpBTMTmgx9aFV5EE782Oss6bi1tAVRUuuRe27-vJ0-9W5=w544-h544-l90-rj",
            releaseLink: "https://sp.universal-music.co.jp/bluejourney/yoakenouta/",
            isShow: false,
        },
        {
            name: "Over Time",
            description: "",
            releaseDate: "2022/07/30",
            artworkUrl: "https://yt3.googleusercontent.com/X6buku8AsI4GRmqeB6v8J2q4eIDumoJtO3ur_fJgzLcVyBbuyX-rCUGlb4jILGTRqwuj1Iuhj_rBBORA=w544-h544-l90-rj",
            releaseLink: "https://cover.lnk.to/epovertime",
            isShow: false,
        },
        {
            name: "マドロミ",
            description: "",
            releaseDate: "2021/10/14",
            artworkUrl: "https://yt3.googleusercontent.com/lzxS3utUhgVw50Q4844ToT-_0MGyRJK7su4VkUXHpI5rwgi40yBgIxS22bRSgl76PrE7i9p2NvWoQPHg-g=w544-h544-l90-rj",
            releaseLink: "https://cover.lnk.to/Madoromi",
            isShow: false,
        },
        {
            name: "#ウチらしか勝たん",
            description: "",
            releaseDate: "2026/07/10",
            artworkUrl: "https://yt3.googleusercontent.com/BDyTO8bUzhO1QVqPt1vpMaUQwwPQhtO_aU8b5sq4syckRtMXTwlo8r5O9taEELHKjVo2uaNkCo9tTw=w544-h544-l90-rj",
            releaseLink: "https://cover.lnk.to/q7WIF0",
            isShow: false,
        },
        {
            name: "SM4SH IT UP",
            description: "",
            releaseDate: "2026/08/09",
            artworkUrl: "https://yt3.googleusercontent.com/vgKXEIsrj7zb-YPJ66KlWmuO53CN5ZoV6EAdZr9dW8PXPzkcv2j_cbS2GINRUpuXSqsBMogViIkBWgM9=w544-h544-l90-rj",
            releaseLink: "https://cover.lnk.to/QVD2hV",
            isShow: false,
        },
        {
            name: "Rewrite the Answer",
            description: "",
            releaseDate: "2026/10/09",
            artworkUrl: "https://yt3.googleusercontent.com/9rnD9eJ33qkdI8pSWjL7smuYviR3niE9m0sDWfLbhYnKiAHodof7xQUMMYe5OQbO9vZ64r0zZ9kwG8_Q=w544-h544-l90-rj",
            releaseLink: "https://cover.lnk.to/OCa2Jk",
            isShow: false,
        }
    ]
}